<template>
  <v-layout align-content-center justify-center>

      <v-card width="100%"
    flat
       :class="{
        'pa-4 mt-4': $vuetify.breakpoint.smAndUp,
        'pa-4  mt-4 mx-4': $vuetify.breakpoint.xs,
      }">
         <v-card-text class="text-center">
          <v-icon color="primary" class=" vicon-noaccess">icons8-no-access</v-icon>
          <h2 class="font-weight-bold primary--text my-5">Access denied</h2>
          <span  class="subtitle-1 my-5"
            >You need to verify your email to access our platform. Check your email for verification the link.</span
          >
          <v-divider></v-divider>
          <br />
          <v-hover v-slot:default="{ hover }">
          <v-btn
            class="caption font-weight-light  py-2"
            color="primary"
            :elevation="hover ? 12 : 2"
            rounded
             @click="goToLink"
            ><span class="subtitle text-uppercase">Login</span></v-btn
          ></v-hover>
        </v-card-text>
      </v-card>
 
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import Vue from "vue";

export default {
  name: "NoAccess",
  data() {
    return {
    };
  },
  computed: {
   
  },
  methods: {
    goToLink: function() {
       this.$firebase.auth.signOut().then(() => {
        this.$router.push("/login").catch(err => {});
        this.$store.commit("setUser", null);
      });
    }
  }
};
</script>

<style>
.accessDiv {
  display: inline-block;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
  margin: 5%;
  height: 70%;
}

.accessDiv p {
  font-size: 5vh;
  font-weight: bold;

  padding: 0;
}

.vicon-noaccess{
    font-size:130px !important;
}

.accessDiv p:after {
  content: attr(data-h1);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  color: transparent;

  background-size: 400%;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.25);
  animation: animateTextBackground 10s ease-in-out infinite;
}
.accessDiv p {
   color: var(--v-primary-base); /* fallback for old browsers */

  font-size: 3vh;
  font-weight: bold;
  line-height: 4vh;
  max-width: 600px;
  position: relative;
  margin: 2%;
}
.accessDiv h1 + p:after {
  content: attr(data-p);
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  color: transparent;
  text-shadow: 1px 1px 2px rgba(255, 255, 255, 0.5);
  -webkit-background-clip: text;
  -moz-background-clip: text;
  background-clip: text;
}
</style>
